import {ConfigService} from './ConfigService';

const Config = ConfigService;
export default Config;